import * as React from "react";
const SvgVector = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 15 17"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.066 10.843c.007-.358-.746-.361-.743 0v.337a.291.291 0 0 1-.485.185.3.3 0 0 1-.095-.185v-.337a.276.276 0 0 0-.29-.26H.29a.277.277 0 0 0-.29.26v5.326a.275.275 0 0 0 .29.26H1.78a.276.276 0 0 0 .29-.26zM14.908 12.739a.464.464 0 0 0-.632-.22l-4.034 2.19a.3.3 0 0 1-.14.037H7.39a.29.29 0 0 1-.285-.29.29.29 0 0 1 .285-.29h2.26c.175.004.32-.215.294-.425a1.23 1.23 0 0 0-1.001-1.187l-2.02-.25c-1.05-.055-1.993-1.09-2.99-1.303-.337-.094-.955.043-1.285.07v4.6l2.557 1.14c.29.13.605.194.922.189l3.32-.076c.441-.012.868-.156 1.225-.414l4.07-2.876a.71.71 0 0 0 .167-.895"
    />
    <path
      fill="currentColor"
      d="M3.83 10.399c1.109.074 2.066 1.221 3.161 1.332l2.023.249a1.823 1.823 0 0 1 1.504 1.92c.557-.302 2.846-1.542 3.36-1.822 1.12-3.594-1.86-6.604-2.856-7.484-.897.836-3.558.832-4.463-.006-.85.721-3.09 2.902-3.07 5.799q.171-.02.342.011m7.158-.478a.863.863 0 0 1-.865.853.866.866 0 0 1-.865-.853.86.86 0 0 1 .865-.854.866.866 0 0 1 .865.854m-.981-3.79a.29.29 0 0 1 .464.349L7.615 10.27a.291.291 0 0 1-.464-.35zM7.499 5.89a.866.866 0 0 1 .855.863.86.86 0 0 1-.855.863.866.866 0 0 1-.855-.863.86.86 0 0 1 .855-.863"
    />
    <path
      fill="currentColor"
      d="M7.093 4.281a4.4 4.4 0 0 0 3.213.107c.813-.301.765-1.581-.056-1.822a.83.83 0 0 0-.502.009 3.07 3.07 0 0 1-1.976-.02c-.985-.226-1.485 1.19-.68 1.726M7.517 1.952c.17-.008.34.016.502.07a2.4 2.4 0 0 0 1.54.003 1.4 1.4 0 0 1 .448-.076c.358-.43.608-.94.728-1.486.006-.272-.06-.338-.06-.338a.67.67 0 0 0-.329.147.29.29 0 0 1-.377-.017.602.602 0 0 0-.984.003.294.294 0 0 1-.444.035A.78.78 0 0 0 7.97 0c-.425.086-.316.36-.627.377-.217.006-.238-.208-.452-.261a.09.09 0 0 0-.087.014c-.235.435.197 1.213.714 1.822M9.838 9.92a.283.283 0 0 0 .484.199.28.28 0 0 0 .085-.198.284.284 0 0 0-.569 0M7.5 7.036a.285.285 0 0 0 .198-.483.28.28 0 0 0-.199-.085.285.285 0 0 0-.198.483.28.28 0 0 0 .198.085"
    />
  </svg>
);
export default SvgVector;
